import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Brush = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      viewBox="0 0 12 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          d="M17.333 4c.342 0 .624.257.663.589l.004.078v6.666a.664.664 0 01-.09.334c.057.097.09.211.09.333v2a2 2 0 01-2 2h-1.333v1.333a2.667 2.667 0 01-2.534 2.664L12 20a2.667 2.667 0 01-2.667-2.667V16H8a2 2 0 01-1.997-1.882L6 14v-2c0-.122.033-.236.09-.334a.652.652 0 01-.086-.255L6 11.333V4.667c0-.342.257-.624.589-.663L6.667 4h10.666zm-.666 8.667H7.333V14c0 .342.257.624.59.662l.077.005h2c.368 0 .667.298.667.666v2a1.333 1.333 0 102.666 0v-2c0-.368.299-.666.667-.666h2a.666.666 0 00.667-.667v-1.333zm0-7.334H7.333v6h9.334v-6z"
          id="brush_line_a"
        />
      </defs>
      <g transform="translate(-6 -4)" fill="none" fillRule="evenodd">
        <mask id="brush_line_b" fill="#fff">
          <use xlinkHref="#brush_line_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#brush_line_a" />
        <g
          mask="url(#brush_line_b)"
          fill={props.color || theme.palette.grey800}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      viewBox="0 0 12 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          d="M6 4v7.333h12V4H6zm2.667 11.333H10V18a2 2 0 104 0v-2.667h1.333A2.667 2.667 0 0018 12.667H6a2.667 2.667 0 002.667 2.666zm3.333 2a.667.667 0 110 1.334.667.667 0 010-1.334z"
          id="brush_solid_a"
        />
      </defs>
      <g transform="translate(-6 -4)" fill="none" fillRule="evenodd">
        <mask id="brush_solid_b" fill="#fff">
          <use xlinkHref="#brush_solid_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#brush_solid_a" />
        <g
          mask="url(#brush_solid_b)"
          fill={props.color || theme.palette.grey800}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
